var u = Object.defineProperty;
var n = (o, t, e) => t in o ? u(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e;
var i = (o, t, e) => (n(o, typeof t != "symbol" ? t + "" : t, e), e);
import { fabric as d } from "fabric";
import { createLogoFabricImg as m, createLogoOuterBox as g } from "./index.es393.js";
import "@turf/turf";
import "./index.es175.js";
import { DEFAULT_CALLOUT_BOX_SIZE as s, getCalloutBoxSizeData as b } from "./index.es176.js";
const r = {
  idle: {
    default: {
      fill: "#FFFFFF",
      rx: 4,
      ry: 4
    },
    light: {
      stroke: "#49565D",
      strokeWidth: -1
    },
    dark: {
      stroke: "white",
      strokeWidth: 0
    }
  },
  dragStart: {
    default: {},
    light: {},
    dark: {}
  },
  select: {
    default: {},
    light: {},
    dark: {}
  },
  selectedPOI: {
    default: {
      fill: "white",
      strokeWidth: -1,
      stroke: "#49565D"
    },
    light: {},
    dark: {}
  }
};
class z {
  constructor(t) {
    i(this, "objType");
    i(this, "layerGroupId");
    i(this, "subLayerId");
    i(this, "combinedLayerId");
    i(this, "styleType");
    i(this, "poiInfo");
    i(this, "thumbnailSize");
    i(this, "outerBox");
    i(this, "thumbnailImg");
    i(this, "thumbnailImgBox");
    i(this, "thumbnailObj");
    i(this, "calloutBoxSizeData");
    i(this, "logoImage", async () => {
      if (this.poiInfo.logoImgBlob)
        return m({
          logoImgBlob: this.poiInfo.logoImgBlob,
          logoImgURL: this.poiInfo.logoImgURL,
          targetWidth: this.thumbnailSize,
          targetHeight: this.thumbnailSize,
          padding: 4,
          devicePixelRatio: 2
        });
    });
    i(this, "generate", async () => {
      const t = await this.logoImage();
      t && (this.thumbnailImgBox = g({
        targetWidth: this.thumbnailSize + 5,
        targetHeight: this.thumbnailSize + 5,
        outerBoxOption: {
          originX: "center",
          originY: "center"
        }
      }), this.thumbnailImg = t, this.outerBox = this.thumbnailImgBox);
    });
    i(this, "getTenantsCalloutBoxObjs", () => (this.thumbnailObj = new d.Group(
      [this.outerBox, this.thumbnailImgBox, this.thumbnailImg].filter(
        (t) => t
      )
    ), this.thumbnailObj));
    i(this, "updateStyle", (t, e = "idle") => {
      var l;
      this.styleType = t;
      const a = this.thumbnailSize + 5;
      (l = this.outerBox) == null || l.set({
        ...r.idle.default,
        ...r.idle[t],
        ...r[e].default,
        ...r[e][t],
        width: a,
        height: a
      });
    });
    t = {
      ...t
    }, this.layerGroupId = t.layerGroupId, this.subLayerId = t.subLayerId, this.combinedLayerId = t.combinedLayerId, this.poiInfo = t.poiInfo, this.objType = "Thumbnail", this.styleType = t.styleType;
    const { sizeId: e, rangePosition: a } = t.poiCalloutBoxConfig.calloutBoxSize || s;
    this.calloutBoxSizeData = b(this.objType, e, a), this.thumbnailSize = this.calloutBoxSizeData.size;
  }
  hasSameProps(t) {
    var l, h;
    if (t.drawType !== "Thumbnail")
      return !1;
    const e = this.calloutBoxSizeData.id;
    return (((h = (l = t.calloutBoxConfig) == null ? void 0 : l.calloutBoxSize) == null ? void 0 : h.sizeId) || s.sizeId) === e;
  }
}
export {
  z as Thumbnail,
  r as outerBoxStyle
};
//# sourceMappingURL=index.es512.js.map
